module.exports = "pegasus_template/assets/hexline-instagram.png";